import { Component } from '@angular/core';
import { PageOptimizationBase } from '../base/base.component';

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-create-content',
  templateUrl: './create-content.component.html'
})
export class PageOptimizationCreateContentComponent extends PageOptimizationBase {
  isStepReadyToReject(): boolean {
    return false;
  }
}
